import script from "./CompanyMatchGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyMatchGroup.vue?vue&type=script&setup=true&lang=ts"

import "./CompanyMatchGroup.vue?vue&type=style&index=0&id=320eb560&lang=postcss&scoped=true"

import exportComponent from "/home/runner/work/matchd-frontend/matchd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-320eb560"]])

export default __exports__